import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box, Divider } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useTranslation } from 'react-i18next';
import { routePaths } from '../../../../routePaths';
import { ActionableBox, SecondaryToolbar, Typography } from '../../../../ui-kit';
import BillDetailList from './BillDetailList';

const BillDetailsView = () => {
    const { params: { id } } = useRouteMatch();
    const history = useHistory();
    const { t } = useTranslation();

    const handleBack = () => history.push(routePaths.bills);

    return (
        <>
            <SecondaryToolbar>
                <Box display="flex" flexGrow={1}>
                    <ActionableBox
                        display='flex'
                        alignItems='center'
                        onClick={handleBack}
                        mr={3}
                    >
                        <Box component='span' mr={0.5}>
                            <ArrowBackIcon color='primary' />
                        </Box>
                        <Typography color='primary'>
                            {t('Back')}
                        </Typography>
                    </ActionableBox>
                    <Box py={1}>
                        <Divider orientation='vertical' />
                    </Box>
                    <Box height={48} flexGrow={1} alignItems='center' justifyContent='center' display='flex'>
                        <Typography fontWeight='bold'>{t('Details')}</Typography>
                    </Box>
                </Box>
            </SecondaryToolbar>
            <Box flex={1} display='flex'>
                <BillDetailList billId={id} />
            </Box>
        </>
    );
};

export default BillDetailsView;
